<template>
  <el-table :data="tableData" style="width: 100%">
    <el-table-column prop="name" label="姓名" />
    <el-table-column prop="sex" label="性别" width="120" />
    <el-table-column prop="phone" label="手机号" />
    <el-table-column prop="idCard" label="身份证号" />
    <el-table-column prop="company" label="所属公司" />
  </el-table>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from "vue";
import { ElMessage } from "element-plus";
import service from "@/http/request.js";
const emit = defineEmits(["dialogClose"]);

const tableData = ref([{}]);
const init = (row) => {
  service.get('/health/web/appointmentInfo/getAppointmentUser/' + row.id)
    .then(data => {
      console.log(data);
      if (data.data.code == 200) {
        tableData.value = data.data.data
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};

// 暴露初始化方法给父组件
defineExpose({ init });
</script>
<style scoped lang="scss">

</style>
